import React, { FC } from 'react';
import { Col, Row } from 'antd';
import { Target } from 'common/svg';
import { IMonitorSalesSummaryMetric } from 'entities/MonitorSales/MonitorSales.models';
import { ChangeArrow } from 'entities/MonitorSales/components/ChangeArrow';
import { formatValue } from 'entities/MonitorSales/monitorSales.helpers';

interface ISummaryRowProps {
  label: string;
  metric?: IMonitorSalesSummaryMetric;
}

export const SummaryRow: FC<ISummaryRowProps> = ({ label, metric }) => {
  const { actual = 0, target = 0, percent = 0, vsLastPeriod = 0, vsLastYear = 0 } = metric ?? {};

  return (
    <Row align="middle" gutter={24} className="mb-4">
      <Col span={18} className="ms-summary__main">
        <Row justify="space-between" className="mb-2">
          <Row gutter={[6, 0]}>
            <Col>{label}</Col>
            <Col>
              <span className="color-gray-1">{formatValue(label, actual)}</span>
            </Col>
            <Col>·</Col>
            <Col className="color-purple">{percent}%</Col>
          </Row>

          <Row align="middle">
            <Target />
            <span className="color-gray-1">{formatValue(label, target)}</span>
          </Row>
        </Row>
        <div className="ms-summary__progress-bar">
          <div
            className="ms-summary__progress-bar-fill"
            style={{ width: `${Math.min(percent, 100)}%`, opacity: percent >= 100 ? 1 : 0.4 }}
          />
        </div>
      </Col>

      <Col span={3} className={`ms-summary__change ms-summary__change--${vsLastPeriod >= 0 ? 'pos' : 'neg'}`}>
        <span>
          {vsLastPeriod >= 0 ? '+' : ''}
          {vsLastPeriod}%
        </span>
        <ChangeArrow up={vsLastPeriod >= 0} />
      </Col>

      <Col span={3} className={`ms-summary__change ms-summary__change--${vsLastYear >= 0 ? 'pos' : 'neg'}`}>
        <span>
          {vsLastYear >= 0 ? '+' : ''}
          {vsLastYear}%
        </span>
        <ChangeArrow up={vsLastYear >= 0} />
      </Col>
    </Row>
  );
};
